import { render } from "./ImportMasivo.vue?vue&type=template&id=2b9b44fb&scoped=true"
import script from "./ImportMasivo.vue?vue&type=script&lang=js"
export * from "./ImportMasivo.vue?vue&type=script&lang=js"

import "./ImportMasivo.vue?vue&type=style&index=0&id=2b9b44fb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\esteb\\Desktop\\PlantillaEsteban\\fronted-plantilla\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9b44fb"]])

export default __exports__